import React from 'react';
import EventCard from './EventCard';

export interface EventItem {
  id: string;
  image: string;
  title: string;
  slug: string;
  event_date: string; // YYYY-MM-DD
  is_active: boolean;
  is_reserved?: boolean;
  admins: string[];
  created_at: string;
  updated_at: string;
  featured?: boolean;
}

interface EventsGridProps {
  events: EventItem[];
}

const EventsGrid: React.FC<EventsGridProps> = ({ events }) => {
  return (
    <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {events.map((e) => (
        <EventCard key={e.id} {...e} />
      ))}
    </div>
  );
};

export default EventsGrid;
